/**
 * Backend API origin from Vite env (see env/.env.example).
 * Example: http://localhost:5000  →  http://localhost:5000/api
 */
const rawBase = (import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000').replace(
	/\/+$/,
	'',
)

export const apiHost = rawBase.endsWith('/api') ? rawBase : `${rawBase}/api`
